module.exports = __webpack_public_path__ + "media/images/front/varieties/BARBERINA-9e160a501deb30e574df8d6e8546b591.jpg";